import { useState } from "react";

import UserMenuItem from "components/user/UserMenuItem";

import AboutModal from "./AboutModal";

interface AboutMenuItemProps {
  onClose?: () => void;
}

// Owns the modal so it outlives the menu popover closing.
function AboutMenuItem({ onClose = undefined }: AboutMenuItemProps) {
  const [open, setOpen] = useState(false);

  const openAbout = () => {
    setOpen(true);
    onClose?.();
  };

  return (
    <>
      <UserMenuItem testId="user-menu-about" onClick={openAbout}>
        About
      </UserMenuItem>
      <AboutModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}

export default AboutMenuItem;
